import React from 'react';
import PropTypes from 'prop-types';

import { DropdownButton, MenuItem } from 'react-bootstrap'
import FaCaretDown from 'react-icons/lib/fa/caret-down';
// import getSymbolFromCurrency from 'currency-symbol-map'
import { isMobile, isBrowserSafari } from '../../../utils';


import './prices.css';

const Prices = ({ onInputChange, priceMin, priceMax, priceFinal, priceSelect, priceSelected, selectCurrency, selectedCurrency, type }) => {
    const renderCurrencyButton = (selectedCurrency) => {
        let title = 'בחירה';

        if (selectedCurrency !== undefined) {
            title = selectedCurrency;
        }

        return (
            <div className="menu-button-wrapper">
                <p>{title}</p>
                <div className="caret-wrapper">
                    <i className="caret"><FaCaretDown /></i>
                </div>
            </div>
        )
    };

    const getSafariClass = () => isBrowserSafari() ? 'safari' : '';

    return (
        <div className={`price-select-wrapper rtl ${getSafariClass()}`}>
            {!isMobile() ? <p className="price-selection-label">כמה עולה?</p> : null}
            <div className="price-inner-wrapper">
                <span
                    className={`price-label ${priceSelected === 'price' ? 'selected' : ''} ${type}`}
                    onClick={() => priceSelect('price')}
                >מחיר</span>

                <div className={`input-wrapper ${priceSelected === 'price' ? '' : 'disabled'} ${type}`}>
                    <input onChange={event => onInputChange(event)}
                           name="priceFinal"
                           type="number"
                           step="0.01"
                           disabled={priceSelected !== 'price'}
                           value={priceFinal}
                           className={`price-input ${priceSelected === 'price-range' ? 'disabled' : ''} ${type}`}
                    />

                    <div className={`currency-wrapper ${type}`}>
                        {/*<p>Currency</p>*/}
                        <DropdownButton
                            title={renderCurrencyButton(selectedCurrency)}
                            id="dropdown"
                            noCaret={true}
                        >
                            <MenuItem eventKey="EUR" onSelect={(eventKey) => selectCurrency(eventKey)}>EUR</MenuItem>
                            <MenuItem eventKey="USD" onSelect={(eventKey) => selectCurrency(eventKey)}>USD</MenuItem>
                            <MenuItem eventKey="ILS" onSelect={(eventKey) => selectCurrency(eventKey)}>ILS</MenuItem>
                            <MenuItem eventKey="JPY" onSelect={(eventKey) => selectCurrency(eventKey)}>JPY</MenuItem>
                            <MenuItem eventKey="CAD" onSelect={(eventKey) => selectCurrency(eventKey)}>CAD</MenuItem>
                            <MenuItem eventKey="AUD" onSelect={(eventKey) => selectCurrency(eventKey)}>AUD</MenuItem>
                            <MenuItem eventKey="GBP" onSelect={(eventKey) => selectCurrency(eventKey)}>GBP</MenuItem>
                        </DropdownButton>
                        <div className="down-arrow">
                        </div>
                    </div>
                </div>

                {/*<span className="currency-symbol">{getSymbolFromCurrency(selectedCurrency || 'ILS')}</span>*/}
            </div>

            <div className="price-range-inner-wrapper">
                <div
                    className={`price-range-label ${priceSelected === 'price-range' ? 'selected' : ''} ${type}`}
                    onClick={() => priceSelect('price-range')}
                >טווח מחירים</div>
                <div className={`range-input-wrapper ${priceSelected !== 'price-range' ? 'disabled' : ''} ${type}`}>
                    <input onChange={event => onInputChange(event)}
                           className={`price-range min-price ${priceSelected === 'price' ? 'disabled' : ''} ${type}`}
                           name="priceRangeMin"
                           type="number"
                           disabled={priceSelected !== 'price-range'}
                           value={priceMin}
                           step="0.01"
                    />
                    <span className={`range ${type}`}>-</span>
                    <input onChange={event => onInputChange(event)}
                           name="priceRangeMax"
                           type="number"
                           step="0.01"
                           value={priceMax}
                           disabled={priceSelected !== 'price-range'}
                           className={`price-range ${priceSelected === 'price' ? 'disabled' : ''} ${type}`}
                    />

                    <div className={`currency-wrapper ${type}`}>
                        <DropdownButton
                            title={renderCurrencyButton(selectedCurrency)}
                            id="dropdown"
                            noCaret={true}

                        >
                            <MenuItem eventKey="EUR" onSelect={(eventKey) => selectCurrency(eventKey)}>EUR</MenuItem>
                            <MenuItem eventKey="USD" onSelect={(eventKey) => selectCurrency(eventKey)}>USD</MenuItem>
                            <MenuItem eventKey="ILS" onSelect={(eventKey) => selectCurrency(eventKey)}>ILS</MenuItem>
                            <MenuItem eventKey="JPY" onSelect={(eventKey) => selectCurrency(eventKey)}>JPY</MenuItem>
                            <MenuItem eventKey="CAD" onSelect={(eventKey) => selectCurrency(eventKey)}>CAD</MenuItem>
                            <MenuItem eventKey="AUD" onSelect={(eventKey) => selectCurrency(eventKey)}>AUD</MenuItem>
                            <MenuItem eventKey="GBP" onSelect={(eventKey) => selectCurrency(eventKey)}>GBP</MenuItem>
                        </DropdownButton>
                        <div className="down-arrow">
                        </div>
                    </div>
                </div>
            </div>
            {type === 'liveMusic' ?
                <div className="price-hat-inner-wrapper">
                    <span className={`price-label ${priceSelected === 'hat' ? 'selected' : ''} ${type}`} onClick={() => priceSelect('hat')}>
                        כובע
                    </span>
                </div>
            : null}
            {type === 'liveMusic' ?
                <div className="price-free-inner-wrapper">
                    <span className={`price-label ${priceSelected === 'free' ? 'selected' : ''} ${type}`} onClick={() => priceSelect('free')}>
                        חינם
                    </span>
                </div>
            : null}
            {isMobile() ? <p className="price-selection-label">כמה עולה?</p> : null}
        </div>
    )
};

Prices.propTypes = {
    type: PropTypes.string,
    onInputChange: PropTypes.func,
    priceSelect: PropTypes.func,
    selectCurrency: PropTypes.func,
    priceMin: PropTypes.number,
    priceMax: PropTypes.number,
    priceFinal: PropTypes.number,
    selectedCurrency: PropTypes.string,
    priceSelected: PropTypes.string
};

export default Prices;



// WEBPACK FOOTER //
// ./src/Components/Users/Submit/Prices.js